import { whatsappUrl } from "@/lib/site";

export function CTASection({
  title = "Quer descobrir como está o atendimento da sua empresa hoje?",
  text = "Solicite um diagnóstico comercial e veja onde seus leads travam, quanto isso custa e como estruturamos o processo de atendimento para vender mais.",
  buttonLabel = "Quero meu diagnóstico gratuito",
}: {
  title?: string;
  text?: string;
  buttonLabel?: string;
}) {
  return (
    <section className="py-16 md:py-20">
      <div className="container-svg">
        <div className="relative overflow-hidden rounded-3xl border border-border shadow-[var(--shadow-soft)] bg-[image:var(--gradient-hero)] p-8 md:p-14">
          <div className="relative max-w-2xl">
            <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{title}</h2>
            <p className="mt-4 text-base text-muted-foreground md:text-lg">{text}</p>
            <a href={whatsappUrl()} target="_blank" rel="noopener" className="btn-primary mt-8">{buttonLabel}</a>
          </div>
        </div>
      </div>
    </section>
  );
}